import * as React from 'react';
import * as EDTools from '../utils/EDTools';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { useEffect, useState } from 'react';
import { TileLayout } from '@progress/kendo-react-layout';
import { Popup } from "@progress/kendo-react-popup";
import { ArcGauge } from '@progress/kendo-react-gauges';
import { useLocation } from 'react-router-dom';
import { useGlobalState } from '../App.js';
import CallInIcon from "./..//assets/comm-icons/call-in.svg";
import { StackLayout } from "@progress/kendo-react-layout";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset, faCalendarCheck, faChartLine, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Chart, ChartTitle, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartLegend, ChartCategoryAxisTitle, ChartCategoryAxisItem } from '@progress/kendo-react-charts';
import { Card, CardHeader, CardTitle, CardBody, CardActions, CardImage, CardSubtitle, Avatar } from '@progress/kendo-react-layout';

const colors = [
    {
        color: '#0058e9',
    },
];


var agentMap = EDTools.EDMakeAgentMap();
var vQueueMap = EDTools.EDMakeQueueMap(); 
 

const dbOptions = {
    StatusReadyColor: '#37B400',
    StatusNotReadyColor: '#FF6358',
    StatusWrapupColor: '#ADD8E6',
    StatusBusyColor: '#FFC000',
    StatusPresenceProfileColor: '#CC8899',
    StatusLoggedOutColor: '#C0C0C0',
    AgentsShowLoggedOutAll: false,
    AgentsShowLoggedOutActiveCurrentDay: true,
    Timezone: 'America/Chicago',
    AgentAvatarFormat: 'FirstName LastName'
};


export const FMDashboardAgents = () => {
    const [loginInfo, updateLoginInfo] = useGlobalState();

    const [layout, setLayout] = React.useState("stretched");
    const [showCallsDuration, setShowCallsDuration] = React.useState(true);
    const emailsDurationAnchor = React.useRef(null);
    const [showEmailsDuration, setShowEmailsDuration] = React.useState(true);
    const [queueLData, setQueueLData] = React.useState(new Map());
    const [agentLData, setAgentLData] = React.useState(new Map());
    const [agentLDataSorted, setAgentLDataSorted] = React.useState([]);
    const [callHistoryData, setCallHistoryData] = React.useState(EDTools.EDMakeEmptyContactHistory());
    const [emailHistoryData, setEmailHistoryData] = React.useState(EDTools.EDMakeEmptyContactHistory());
    const [dashboardData, setDashboardData] = React.useState({
        "numMessagesActive": 0,
        "totalNumMessages": 0,
        "numRoutesActive": 0,
        "totalNumRoutes": 0,
        "activeRouteDetails": "No Active Route Defined",
        "numCustomMessagesActive": 0,
        "totalNumCustomMessages": 0,
        "messages": {},
        "routes": {}
    });
    const [queueTiles, setQueueTiles] = React.useState([]);

    const [connection, setConnection] = React.useState();
    const [isConfigured, setConfigured] = React.useState(false);

    const dashboardId = "42cbbc39-2874-4993-ba47-689ac029c49c";

    useEffect(() => {
         
         const connect = new HubConnectionBuilder()
            .withUrl("https://eyedogzsloan.covington.io/dashboard")
            .configureLogging(LogLevel.Information)
            .withAutomaticReconnect()
            .build();

        setConnection(connect);
    }, []);

    useEffect(() => {
        if (connection) {
            connection
                .start()
                .then(() => {
                    connection.on("initiated", (Message) => {
                        console.log(Message);
                    });
                    connection.on("updateStats", (Message, index) => {
                        console.log(Message + ', index: ' + index);
                    });
                    connection.on("statusUpdate", (Message) => {
                        console.log("statusUpdate RECEIVED");
                        console.log(Message);
                        agentMap = EDTools.EDVAgentZeroData(agentMap);
                        console.log("statusUpdate. Agent Map before:")
                        console.log(agentMap);
                        agentMap = EDTools.EDProcessAgentUserStatistics(agentMap, Message.userStatistic);
                        agentMap = EDTools.EDProcessAgentUserStatus(agentMap, Message.userStatus);
                        agentMap = EDTools.EDProcessAgentUserStatisticsDay(agentMap, Message.userStatisticDay);
                        console.log("agent map after");
                        console.log(agentMap);
                   //     vQueueMap = EDTools.EDVQueueZeroData(vQueueMap);
                    //    console.log("vqueue map after zeroing");
                   //     for (let [key, value] of vQueueMap) {
                   //         console.log(key + " = " + JSON.stringify(value));
                  //      }
                   //     vQueueMap = EDTools.EDProcessQueueStatusV(vQueueMap, Message.queueStatus);
                    //    vQueueMap = EDTools.EDProcessQueueStatisticV(vQueueMap, Message.queueStatistic);

                   //     console.log("vqueue map after update for vqueues");
                   //     for (let [key, value] of vQueueMap) {
                   //         console.log(key + " = " + JSON.stringify(value));
                   //     }
                   //     setQueueLData(vQueueMap);
                        var sortedAgents = EDTools.EDGetSortedArray(Array.from(agentMap.values()));
                        setAgentLData(agentMap);
                        setAgentLDataSorted(sortedAgents);

                    //    var contactHistories = EDTools.EDProcessContactHistory(Message.contactHistory);
                    //    console.log("contactHistories map after update for histories");
                    //    for (let [key, value] of contactHistories) {
                    //        console.log(key + " = " + JSON.stringify(value));
                    //    }
                      //  var phoneHistories = EDTools.EDMakeContactHistoryArray(contactHistories, '8BE8B37D8A0A45CA8CAAE8EDC29439E4');
                      //  var emailHistories = EDTools.EDMakeContactHistoryArray(contactHistories, 'D576F0F51C204CADA6AB55ACEB3C6D95');
                      //  setCallHistoryData(phoneHistories);
                      ///  setEmailHistoryData(emailHistories);
                    });
                    connection.on("configUpdate", (Message) => {
                        console.log("configUpdate RECEIVED");
                        console.log(Message);
                        configureDashboard(Message);
                    })

                    var validConnId = connection?.invoke("LoadDbConfig", dashboardId);

                    var connectionId = connection?.invoke("SubscribeForData", dashboardId);
                    console.log("SubscribeForData returns: " + connectionId);
                }).catch((error) => console.log(error));
        }

    }, [connection]);

    const configureDashboard = (config) => {
        console.log("configureDashboard [Begin]");
        console.log(agentMap);
        var idx = 0;
        if (config.userSubs === null) {
            EDTools.EDLog("userSubs is null");
        }
        else if (config.userSubs.length === 0) {
            EDTools.EDLog("userSubs is empty");
        }
        else {
            for (idx = 0; idx < config.userSubs.length; idx++) {
                var currUser = config.userSubs[idx];
                agentMap = EDTools.EDSubscribeAgent(agentMap, currUser.esUserId, currUser);
                console.log("subscribe: " + currUser.esUserId);
                console.log(agentMap);
            }
        }
    //    if (config.virtualQueueSubs === null) {
    //        EDTools.EDLog("virtualQueueSubs is null");
    //    }
    //    else if (config.virtualQueueSubs.length === 0) {
   //         EDTools.EDLog("virtualQueueSubs is empty");
   //     }
   //     else {
  //          for (idx = 0; idx < config.virtualQueueSubs.length; idx++) {
    //            var currVQueue = config.virtualQueueSubs[idx];
   //             vQueueMap = EDTools.EDSubscribeVQueue(vQueueMap, currVQueue.edDashoardVirtualQueueId, currVQueue);
   //             console.log("subscribe vQueue: " + currVQueue.edDashoardVirtualQueueId + " Contains:");
   //             for (let [key, value] of vQueueMap) {
    //                console.log(key + " = " + JSON.stringify(value));
    //            }
    //        }
    //    }

    //    setQueueLData(vQueueMap);
        setAgentLData(agentMap);
        setAgentLDataSorted(Array.from(agentMap.values()));


        setConfigured(true);
        console.log("configureDashboard. Agent Map:");
        console.log(agentMap);
        console.log("configureDashboard [End]");
    }

    const handleReposition = (e) => {
        setData(e.value);
    };

    useEffect(() => {
        loadState();
    }, []);

    const loadState = () => {


    }

    const [data, setData] = React.useState([
        {
            col: 1,
            colSpan: 3,
            rowSpan: 2,
        },
        {
            col: 1,
            colSpan: 2,
            rowSpan: 3,
        },
    ]);

    const [callsPerHour, emailsPerHour] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
    const hours = ['5 am', '6 am', '7 am', '8 am', '9 am', '10 am', '11 am', '12 pm', '1 pm', '2 pm', '3 pm', '4 pm', '5 pm', '6 pm'];

    const agentStatus = [{
        category: 'Ready',
        value: 2,
        color: '#37B400'
    }, {
        category: 'Not Ready',
        value: 4,
        color: '#FF6358'
    }, {
        category: 'Busy',
        value: 3,
        color: '#FFC000'
    }, {
        category: 'Wrap-up',
        value: 1,
        color: 'LightBlue'
    }];


    const labelContent = props => {
        if (props.dataItem.value !== 0)
            return `${props.dataItem.value}`;
        else
            return '';
    };



    const tiles = [ 
        {
            defaultPosition: {
                col: 1,
                colSpan: 6,
                rowSpan: 3,
            },
            header: <span class="k-card-title top-align-edz"><span class="material-symbols-outlined top-align-edz">support_agent</span >&nbsp;Agents</span>,
            body: <div style={{
                display: 'flex',
                justifyContent: 'space-evenly',
                flexWrap: 'wrap'
            }
            } >
                {
                    Array.from(agentLDataSorted).map((card, index) => {
                        return <div key={index}>
                            <Card style={{
                                width: 260,
                                boxShadow: '0 0 4px 0 rgba(0, 0, 0, .1)',
                                marginTop: '15px'
                            }}>
                                <CardHeader className="k-hbox" style={{
                                    background: 'transparent',
                                    padding: '12px'

                                }}>
                                    <Avatar type='text' size='medium' shape='circle' style={{ backgroundColor: EDTools.EDGetStatusColor(dbOptions, card.status) }}>{card.avatarName}</Avatar>
                                    <div>
                                        <CardTitle style={{
                                            marginBottom: '4px'
                                        }}>{card.name}</CardTitle>
                                        <CardSubtitle><p><b>{card.status}</b></p></CardSubtitle>
                                    </div>

                                </CardHeader>
                                <CardBody style={{ padding: '12px' }}>
                                    <StackLayout orientation={"horizontal"} align={{ horizontal: "stretch" }}>
                                        <div class="agent-data-table-hleft"></div>
                                        <div class="agent-data-table-hcenter">In</div>
                                        <div class="agent-data-table-hcenter">Done</div>
                                        <div class="agent-data-table-hright">Out</div>
                                    </StackLayout>
                                    <StackLayout orientation={"horizontal"} align={{ horizontal: "stretch" }}>
                                        <div class="agent-data-table-hleft">
                                            <span class="material-symbols-outlined">
                                                call
                                            </span>
                                        </div>
                                        <div class="agent-data-table-hcenter">{card.numCallsOffered}</div>
                                        <div class="agent-data-table-hcenter">{card.numCallsHandledIn}</div>
                                        <div class="agent-data-table-hright">{card.numCallsHandledOut}</div>
                                    </StackLayout>
                                    <StackLayout orientation={"horizontal"} align={{ horizontal: "stretch" }}>
                                        <div class="agent-data-table-hleft"><span class="material-symbols-outlined">
                                            phone_callback
                                        </span></div>
                                        <div class="agent-data-table-hcenter">{card.numCallbacksOffered}</div>
                                        <div class="agent-data-table-hcenter">{card.numCallbacksHandled}</div>
                                        <div class="agent-data-table-hright">{card.numCallbacksOut}</div>
                                    </StackLayout>
                                    <StackLayout orientation={"horizontal"} align={{ horizontal: "stretch" }}>
                                        <div class="agent-data-table-hleft">
                                            <span class="material-symbols-outlined">
                                                mail
                                            </span>
                                        </div>
                                        <div class="agent-data-table-hcenter">{card.numEmailsOffered}</div>
                                        <div class="agent-data-table-hcenter">{card.numEmailsHandled}</div>
                                        <div class="agent-data-table-hright">{card.numEmailsOut}</div>
                                    </StackLayout>
                                </CardBody>
                                <CardActions style={{
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}>
                                    <div style={{ textAlign: 'left', paddingRight: '5px' }}>
                                        {card.presenceProfile}
                                    </div>
                                    <span style={{
                                        fontSize: '13px',
                                        alignSelf: 'center',
                                        color: '#656565'
                                    }}><FontAwesomeIcon icon={faChartLine} />&nbsp;
                                        {EDTools.EDAgentGetAvgHandleTime(card)} AHT&nbsp;&nbsp;&nbsp;{card.utilizationPct}% Utilization</span>
                                </CardActions>

                            </Card>
                        </div>;
                    })
                }
            </div >,
        },
    ];


    return (
        <div>
            <div className="DBHeader">
                <StackLayout orientation="horizontal" gap="0">
                    <div className="k-flex-40 DBHeaderTitle">
                        Agents
                    </div>
                    <div className="k-flex-10" />
                    <div className="k-flex-20" />
                    <div className="k-flex-30 right-align" >
                        <img className="DBHeaderLogo" alt="Sloan" src={require("./..//assets/flushmate-logo.png")} ></img>
                    </div>
                </StackLayout>
            </div>

            <TileLayout className="DBLayoutBG" columns={6} items={tiles} rows={3} />

        </div>

    );

    const fetchData = () => {

    }


};


